import React from "react";
import "./inputField.scss";

interface Props {
    id?: string;
    type?: string;
    name?: string;
    classname?: string;
    placeholder?: string;
    defaultValue?: string | number;
    maxCharacter?: number | undefined;
    characterCount?: number | null | undefined;
    error?: any;
    onblur?: (event: React.FocusEvent<HTMLInputElement>) => void | undefined;
    inputValue?: string | number | readonly string[] | undefined;
    onchange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    message?: any;
    autoComplete?: any;
    image?: any;
    label?: string
}

export const InputField: React.FC<Props> = ({
                                                id,
                                                type,
                                                classname,
                                                onchange,
                                                placeholder,
                                                name,
                                                error,
                                                onblur,
                                                inputValue,
                                                defaultValue,
                                                message,
                                                maxCharacter,
                                                autoComplete,
                                                image = null,
                                                label
                                            }) => {
    const characters = React.useRef(null) as any;
    return (
        <div className={'inputField'}>
            {label && <span className={'inputField_label'}>{label}</span>}
            <div className="inputField_container" data-cy={id}>
                <img src={image} alt=""/>
                <input
                    type={type}
                    ref={characters}
                    className={[classname, "inputField_container_input", error ? "inputField_container_input_error" : null, image !== null ? "image_input" : null].join(" ")}
                    onChange={onchange}
                    name={name}
                    placeholder={placeholder}
                    onBlur={onblur}
                    value={inputValue}
                    defaultValue={defaultValue}
                    maxLength={maxCharacter}
                    id={id || ""}
                    autoComplete={autoComplete ? autoComplete : "on"}
                />
            </div>
            <div className="inputField_info_wrapper">
                <span id="--name__error" className="inputField_info_wrapper_message">
                  {message}
                </span>
            </div>

        </div>
    );
};

export default InputField;
